import React, { useEffect, useState } from "react";
import drivado_logo from "../assets/drivado_logo.png";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import driver_photo from "../assets/driver-photo.jpg";
import "./TrakingStatus.css";
import {
  faCalendar,
  faClipboardCheck,
  faMobile,
  faUser,
} from "@fortawesome/fontawesome-free-solid";
import moment from "moment";

const Traking = () => {
  const { id } = useParams();
  const [bookingLink, setbookingLink] = useState();
  const [bookingStatus, setbookingStatus] = useState({});

  const getDriverStatus = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/bookings/bookingTrackLink?bookingId=${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    setbookingStatus(data?.response?.driverStatus);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      getDriverStatus();
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const getBookingLink = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/bookings/bookingTrackLink?bookingId=${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    console.log("response----------------------->", data);
    setbookingLink(data);
  };

  useEffect(() => {
    getBookingLink();
  }, []);

  return (
    <div className="mx-3">
      <div className="relative">
        {/*  <div className=" space-x-20 items-center">
          <img src={DrivadoImage} alt="" />
          <div className="flex justify-center py-3 space-x-6">
            <div className="text-md font-semibold text-teal-700">
              Tracking Status
            </div>
            <div className="flex space-x-2">
              <div className=" flex items-center space-x-1">
                <div className="">
                  <div
                    className={`${
                      bookingLink?.trackingStatus?.ENROUTE_PICKUP_LOCATION
                        ? "bg-teal-600"
                        : "bg-slate-600"
                    }   w-3 h-3 rounded-full `}
                  ></div>
                </div>
                <div className="text-xs">Enroute Pickup Location</div>
              </div>
              <div className=" flex items-center space-x-1">
                <div className="">
                  <div
                    className={`${
                      bookingLink?.trackingStatus?.ARRIVED_PICKUP_LOCATION
                        ? "bg-teal-600"
                        : "bg-slate-600"
                    }   w-3 h-3 rounded-full  `}
                  ></div>
                </div>
                <div className="text-xs">Arrived Pickup Location</div>
              </div>
              <div className=" flex items-center space-x-1">
                <div className="">
                  <div
                    className={`${
                      bookingLink?.trackingStatus?.GUEST_ON_BOARD
                        ? "bg-teal-600"
                        : "bg-slate-600"
                    }  w-3 h-3 rounded-full  `}
                  ></div>
                </div>
                <div className="text-xs">Guest on board</div>
              </div>
              <div className=" flex items-center space-x-1">
                <div className="">
                  <div
                    className={`${
                      bookingLink?.trackingStatus?.GUEST_DROPPED_OFF
                        ? "bg-teal-600"
                        : "bg-slate-600"
                    }  w-3 h-3 rounded-full  `}
                  ></div>
                </div>
                <div className="text-xs">Guest dropped off</div>
              </div>
            </div>
          </div>
                  </div> */}
        {/* <iframe
          className="w-full h-screen"
          src={`${bookingLink?.bookingTrackLink}` }
          title="Tracking"
        /> */}

        <div className="w-full">
          <iframe
            class="w-full h-screen"
            src={bookingLink?.bookingTrackLink}
            title="Tracking"
          ></iframe>
        </div>

        <div className="absolute top-5 left-6">
          <img src={drivado_logo} className="h-10 w-auto" alt="Drivado Logo" />
          {/* <h2 className="mt-2 font-medium text-slate-900 text-sm">
            Support: +91 99034 38356
          </h2> */}
        </div>
        {/* FOR DESKTOP SCREEN md to 2xl */}
        <div className="hidden md:block absolute bottom-20 left-6 w-[357px] h-[251px] xs:w-80 bg-stone-300 bg-opacity-90 rounded-xl box-shadow  border-2 border-white px-2">
          <div className="flex justify-between items-center px-3 pt-3.5 pb-1 border-b-2 border-neutral-400">
            <div className="text-base font-semibold text-zinc-900 text-left">
              <h2 className="text-xs text-neutral-700">Booking ID</h2>{" "}
              {bookingLink?.response?.bookingId}
            </div>
            <div className="text-base font-semibold text-zinc-900 text-right">
              <h2 className="text-xs text-neutral-700">Travel Date</h2>
              {moment(bookingLink?.response?.travelTimeStamp).format(
                "Do MMMM YYYY"
              )}
            </div>
          </div>
          <div className="px-2 pb-2 pt-5 space-y-0.5">
            <div className="flex space-x-3 items-center text-xs">
              <div>
                <img
                  src={driver_photo}
                  className="w-auto h-12 rounded-full"
                  alt="Drivado Logo"
                />
              </div>
              <div>
                <h2 className="font-semibold text-neutral-700 text-xs">
                  Driver Name
                </h2>
                <h2 className="text-zinc-900 text-base font-semibold">
                  {bookingLink?.response?.driverDetails?.name}
                </h2>
                <h2 className="text-neutral-700 text-sm font-normal font-inter tracking-tight">
                  {bookingLink?.response?.driverDetails?.countryCode +
                    " " +
                    bookingLink?.response?.driverDetails?.contactNumber}
                </h2>
              </div>
            </div>

            {/* <div className="flex space-x-1 items-center text-xs">
              <FontAwesomeIcon icon={faMobile} className="text-[#0071f5] w-5" />
              <h2 className="font-normal text-gray-300">Contact No.:</h2>
              <h2>
                {bookingLink?.response?.driverDetails?.countryCode +
                  " " +
                  bookingLink?.response?.driverDetails?.contactNumber}
              </h2>
            </div> */}
            <div className="text-lg pt-8 trackingStatus">
              <ul>
                {bookingStatus?.ENROUTE_PICKUP_LOCATION && (
                  <li className="text-green-600 font-semibold item-1">
                    Enroute Pickup Location
                  </li>
                )}
                { bookingStatus?.ARRIVED_AT_PICKUP_LOCATION && (
                  <li className="text-green-600 font-semibold item-2">
                    Arrived Pickup Location
                  </li>
                )}
                {bookingStatus?.GUEST_ON_BOARD && (
                  <li className="text-green-600 font-semibold item-3">
                    Guest on board
                  </li>
                )}
                {bookingStatus?.GUEST_DROP_OFF && (
                  <li className="text-green-600 font-semibold item-4">
                    Guest dropped off
                  </li>
                )}
                {!bookingStatus?.ENROUTE_PICKUP_LOCATION &&
                  !bookingStatus?.ARRIVED_PICKUP_LOCATION &&
                  !bookingStatus?.GUEST_ON_BOARD &&
                  !bookingStatus?.GUEST_DROPPED_OFF && (
                    <li className="text-red-600 font-semibold item-5">
                      Tracking Not Started
                    </li>
                  )}
              </ul>
            </div>
          </div>
        </div>

        {/* FOR MOBILE SCREEN below md screen */}
        <div className="md:hidden absolute bottom-16 left-0 w-full bg-slate-900 text-white shadow-2xl shadow-zinc-600 rounded-xl">
          <div className="bg-[#0a1224] px-3 py-1 border-b border-[#1b294b] rounded-t-lg">
            <h2 className="text-sm font-medium text-white">
              Tracking Details - {bookingLink?.response?.bookingId}
            </h2>
          </div>
          <div className="px-2 pb-2 pt-1.5 space-y-0.5 sm:space-y-0">
            <div className="sm:flex sm:items-center space-y-0.5">
              <div className="text-xs">
                <h2 className="font-normal text-gray-300 text-xs">
                  Driver Name
                </h2>
                <h2 className="">
                  {bookingLink?.response?.driverDetails?.name}
                </h2>
                <h2>
                  {bookingLink?.response?.driverDetails?.countryCode +
                    " " +
                    bookingLink?.response?.driverDetails?.contactNumber}
                </h2>
              </div>
            </div>
            <div className="sm:flex sm:items-center space-y-0.5">
              <div className="flex space-x-1 items-center text-xs">
                {bookingStatus?.ENROUTE_PICKUP_LOCATION && (
                  <div className="text-green-600 font-semibold item-1">
                    Enroute Pickup Location
                  </div>
                )}
                {bookingStatus?.ARRIVED_PICKUP_LOCATION && (
                  <div className="text-green-600 font-semibold item-2">
                    Arrived Pickup Location
                  </div>
                )}
                {bookingStatus?.GUEST_ON_BOARD && (
                  <div className="text-green-600 font-semibold item-3">
                    Guest on board
                  </div>
                )}
                {bookingStatus?.GUEST_DROPPED_OFF && (
                  <div className="text-green-600 font-semibold item-4">
                    Guest dropped off
                  </div>
                )}
                {!bookingStatus?.ENROUTE_PICKUP_LOCATION &&
                  !bookingStatus?.ARRIVED_PICKUP_LOCATION &&
                  !bookingStatus?.GUEST_ON_BOARD &&
                  !bookingStatus?.GUEST_DROPPED_OFF && (
                    <div className="text-red-600 font-semibold item-5">
                      Tracking Not Started
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Traking;
